import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import Header from '@/components/landing/header'
import Footer from '@/components/landing/footer'

// Site shell: sticky header, page content, footer. Needs the `site` prop from getSiteContent().
export const Layout: FC<LayoutProps> = ({ children, className }): ReactNode => {
    return (
        <>
            <Header />

            <main className={className}>
                {children}
            </main>

            <Footer />
        </>
    )
}
